module.exports = "<template> <div class=geometry-container> <iframe ref=iframe class=map-frame style=width:100%;height:500px></iframe> </div> </template> ";